import React from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import Location from "./Location";

interface IDealer {
  paperProps?: any;
  vehicle: TVehicle;
}

const Dealer: React.FC<IDealer> = ({
  paperProps = { sx: { p: 2 } },
  vehicle,
}): JSX.Element | null => {
  if (!vehicle?.location) return null;

  return (
    <Paper variant="outlined" {...paperProps}>
      <Typography variant="h5" component="h2">
        <FormattedMessage id="common.dealer" defaultMessage="Händler" />
      </Typography>
      <Location location={vehicle.location} />
    </Paper>
  );
};

export default Dealer;
